export const tableHeadConfig = [
  { id: 1, label: 'Location' },
  { id: 2, label: 'Sublocation' },
  { id: 3, label: 'Expiration Date' },
  { id: 4, label: 'Contained In' },
  { id: 5, label: 'Note' },
  { id: 6, label: 'Status' },
  { id: 7, label: 'Min QTY' },
  { id: 8, label: 'BAA', footnote: '[1]' },
  { id: 9, label: 'Current QTY' },
  { id: 10, label: '' }
];
